import { render, staticRenderFns } from "./psychologRegForm.vue?vue&type=template&id=069082a1&scoped=true"
import script from "./psychologRegForm.vue?vue&type=script&lang=js"
export * from "./psychologRegForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069082a1",
  null
  
)

export default component.exports